import React, { Component } from 'react';
import './index.css';

import State from '../State'

class ExpenditureFilter extends Component {

  handleLimitDecrement() {
    let newValue = State.filters.numericRange[0].range[0] / 10
    if(newValue <= 1)
      newValue = 0
    State.action('updateTotalExpenditureLowerLimit', newValue)
  }

  handleLimitIncrement() {
    let newValue
    if(State.filters.numericRange[0].range[0] === 0) {
      newValue = 10
    } else {
      newValue = State.filters.numericRange[0].range[0] * 10
    }
    newValue = newValue > 100000 ? 100000 : newValue

    State.action('updateTotalExpenditureLowerLimit', newValue)
  }

  // console.log(this.state.range)
  render() {
    return (
      <div className="expenditure-filter">
        <div className="subtitle">Only include transactions above:</div>
        <div className="inner">
          <svg width="200px" height="24px">
            <g transform="translate(100,4)">
              <path transform="translate(-80, 2)" d="M0,0 l-10,6 l10,6 z" onClick={this.handleLimitDecrement} />
              {/*<rect x="-35" width="70" height="16" />*/}
              <text className="no-select" y="13">£{State.filters.numericRange[0].range[0]}</text>
              <path transform="translate(80, 2)" d="M0,0 l10,6 l-10,6 z" onClick={this.handleLimitIncrement} />
            </g>
          </svg>
        </div>
      </div>
    )
  }
}

export default ExpenditureFilter;



// WEBPACK FOOTER //
// ./src/ExpenditureFilter/index.js